var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-layout',[_c('v-flex',{attrs:{"xs12":""}},_vm._l((_vm.builds),function(build){return _c('build-list-tile',{key:build.id,attrs:{"build":build}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }